import { Navigate, Outlet } from "react-router-dom";
import { CheckRole, UserRoles } from "../config/roles";

export default function RequireRole({ roles }: { roles: UserRoles[] }) {
    return CheckRole(roles)  ? <Outlet /> : <Navigate to={"/403"} />;
}

